import React, { useEffect, useState } from 'react'
import styles from './TextSearchMarker.module.scss'

interface ITextSearchMarkerProps {
  text: string | ''
  search: string | ''
}
export type TextSearchMarkerProps = ITextSearchMarkerProps

export const TextSearchMarker = (props: TextSearchMarkerProps): JSX.Element => {
  const [text, setText] = useState(props.text)
  const [search, setSearch] = useState(props.search)

  useEffect(() => {
    return () => {
      setText(null)
      setSearch(null)
    }
  }, [])

  useEffect(() => {
    setText(props.text)
    setSearch(props.search)
  }, [props])

  const getTextMarker = (text: string, search: string): { __html: string } => {
    text = !text ? '' : String(text)

    if (search && search.length > 1) {
      search = search.trim()

      let string = text.replace(
        new RegExp(search, 'g'),
        '<mark class="' + styles._marker + '">$&</mark>'
      )

      string = string.replace(
        new RegExp(search.toUpperCase(), 'g'),
        '<mark class="' + styles._marker + '">$&</mark>'
      )

      string = string.replace(
        new RegExp(search.toLowerCase(), 'g'),
        '<mark class="' + styles._marker + '">$&</mark>'
      )

      return {
        __html: string
      }
    }
    return {
      __html: text
    }
  }

  return (<span className={styles._block} dangerouslySetInnerHTML={getTextMarker(text, search)} />)
}
